<template>
  <base-layout>
    <product-details-modal ref="productDetailsModal"/>
    <h1 slot="header">
      {{ `app.pages.products.` + selectedTab | trans }}
    </h1>
    <v-app id="vuetify-app">
      <v-tabs icons-and-text v-model="selectedTab" slider-color="success">
        <v-tab href="#all" v-if="hasPermission('product_list')">
          {{ `app.all`|trans }}
          <v-icon>menu</v-icon>
        </v-tab>
        <v-tab href="#own" v-if="hasPermission('product_own_list')">
          {{ `app.own` | trans }}
          <v-icon>person</v-icon>
        </v-tab>
        <v-tab href="#favorites" v-if="hasPermission('product_favorite_list')">
          {{ `app.favorites` | trans }}
          <v-icon>favorite</v-icon>
        </v-tab>
        <v-tab v-if="canUseSharing" href="#shared">
          {{ `app.shared` | trans }}
          <v-icon>share</v-icon>
        </v-tab>
        <v-tab v-else href="#shared" :disabled="true" v-tooltip="{
        content: trans('app.no_access_tooltip'),
        delay: { show: 500, hide: 2000 },
        autoHide: false,
      }">
          {{ `app.shared` | trans }}
          <v-icon>share</v-icon>
        </v-tab>
        <v-tab-item
            :key="`all`"
            :value="`all`"
        >
          <products-table
              :group="`all`"
              ref="allProducts"
              @editProduct="editProduct"
              @copyAndEditProduct="copyAndEditProduct"
              @showProduct="showProduct"
          >
            <template slot="header_actions">
              <v-flex xs12 sm2 md2 d-flex>
                <manage-product-modal @productCreated="updateTable"/>
              </v-flex>
            </template>
          </products-table>
        </v-tab-item>
        <v-tab-item
            :key="`own`"
            :value="`own`">
          <products-table
              :group="`own`"
              ref="ownProducts"
              @editProduct="editProduct"
              @copyAndEditProduct="copyAndEditProduct"
              @showProduct="showProduct"
          >
            <template slot="header_actions">
              <v-flex xs12 sm2 md2 d-flex>
                <manage-product-modal ref="manageProductModalOwnTab" @productCreated="updateTable"/>
              </v-flex>
            </template>
          </products-table>
        </v-tab-item>
        <v-tab-item
            :key="`favorites`"
            :value="`favorites`">
          <products-table
              :group="`favorites`"
              ref="favoritesProducts"
              @editProduct="editProduct"
              @copyAndEditProduct="copyAndEditProduct"
              @showProduct="showProduct"
          >
            <template slot="header_actions">
              <v-flex xs12 sm2 md2 d-flex>
                <manage-product-modal @productCreated="updateTable"/>
              </v-flex>
            </template>
          </products-table>
        </v-tab-item>
        <v-tab-item
            :key="`shared`"
            :value="`shared`"
        >
          <products-table
              :group="`shared`"
              ref="sharedProducts"
              @editProduct="editProduct"
              @copyAndEditProduct="copyAndEditProduct"
              @showProduct="showProduct"
          >
          </products-table>
        </v-tab-item>
      </v-tabs>
    </v-app>
  </base-layout>
</template>

<style lang="scss" type="text/scss" scoped>
.vue-tooltip {
  .vue-tooltip-arrow {
    display: none;
  }

  .vue-tooltip-inner {
    max-width: 300px;
    opacity: 0.9;
    background: #616161;
  }
}

.v-dialog__content {
  z-index: 1030 !important;
}
</style>

<script>
import {mapGetters} from "vuex";
import {trans} from "../../app";

export default {
  props: {
    group: String,
    product_saved: {
      type: Boolean,
      default: false,
    },
    product_added: {
      type: Boolean,
      default: false
    },
    id: {
        type: Number,
        default: null,
    }
  },
  data: () => ({
    groups: [
      'all',
      'own',
      'favorites',
      'shared',
    ],
    selectedTab: null,
    loadingProduct: false,
  }),
  computed: {
    ...mapGetters(['hasPermission', 'canUseSharing']),
  },
  mounted() {
    if (this.product_added) {
      this.$toast(trans('app.product_added'));
    }
    if (this.product_saved) {
      this.$toast(trans('app.product_saved'));
    }

    if (this.id) {
        this.showProduct({id:this.id});
        return;
    }

    if (window.location.href.includes('/products/own/create')) {
      this.$refs.manageProductModalOwnTab.open();
    }
  },
  created() {
    this.selectedTab = this.group;
  },
  watch: {
    selectedTab: {
      handler() {
        this.$refs[this.selectedTab + 'Products'].fetchData();
      }
    }
  },
  methods: {
    async editProduct(e) {
      if (this.loadingProduct === false) {
        this.loadingProduct = true;
        await this.$refs.manageProductModalOwnTab.editProduct(e.id);
        this.loadingProduct = false;
      }
    },
    async copyAndEditProduct(e) {
      if (this.loadingProduct === false) {
        this.loadingProduct = true;
        await this.$refs.manageProductModalOwnTab.copyAndEditProduct(e.id);
        this.loadingProduct = false;
      }
    },
    async showProduct(e) {
      if (this.loadingProduct === false) {
        this.loadingProduct = true;
        await this.$refs.productDetailsModal.open(e.id);
        this.loadingProduct = false;
      }
    },
    updateTable(event) {
      this.$refs.allProducts.fetchData();
      if (event.isSystem === false) {
        this.$refs.ownProducts.fetchData();
      }
    },
  },
}
</script>
